import { useParams, useNavigate } from "react-router-dom";
import { Link } from "@/i18n/LangRouting";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { LangButton } from "@/visitor/Header";
import { usePageTitle } from "@/lib/pageTitle";
import { Footer } from "@/visitor/SignupPage";

const TITLE_KEY = { impressum: "impressum", privacy: "privacy_policy", gift_terms: "gift_terms" };

export default function LegalPage() {
  const { key } = useParams();
  const navigate = useNavigate();
  const { t, legal, legalText, prefix } = useI18n();
  usePageTitle(t("site_name"));
  if (!TITLE_KEY[key]) return <Link to="/" className="block p-10 text-center text-[var(--muted)]">{t("back")}</Link>;
  const text = legalText(key);
  const version = legal?.[key]?.version;
  return (
    <div className="min-h-screen flex flex-col" data-testid={`legal-page-${key}`}>
      <header className="flex items-center justify-between px-5 h-16 border-b border-[var(--line)] sticky top-0 z-30 backdrop-blur-md bg-[#111111]/85">
        <button type="button" onClick={() => (window.history.length > 1 ? navigate(-1) : navigate(prefix))} className="ctrl -ml-3" aria-label={t("back")} data-testid="legal-back"><ArrowLeft size={22} /></button>
        <LangButton />
      </header>
      <main className="max-w-2xl w-full mx-auto px-6 py-10 flex-1">
        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-[0.95]" data-testid="legal-title">{t(TITLE_KEY[key])}</h1>
        {key === "privacy" && version && <p className="text-xs text-[var(--muted)] mt-2" data-testid="legal-version">{t("privacy_version")} v{version}</p>}
        <div className="mt-8 text-[0.95rem] leading-relaxed text-[#d8d8d8] whitespace-pre-line" data-testid="legal-content">
          {text || <span className="text-[var(--muted)]">{t("legal_empty")}</span>}
        </div>
      </main>
      <div className="max-w-2xl w-full mx-auto px-6 py-8"><Footer t={t} /></div>
    </div>
  );
}
